<template>
  <header class="question__header">
    <div class="header">
      <CurrentStep
        :current="data.currentNumberQuestion + 1"
        :max="data.questionDetails.total_questions"
      />
      <div class="header__timer">
        <div class="timer__count">{{ data.timeLeftToAnswer }}s</div>
        <div class="timer__icon" v-html="clockIcon"></div>
      </div>
      <CoinsCount :coins="data.collectedPoints" />
    </div>
    <BulletList :bullets="data.bullets" />
  </header>
</template>

<script>
import clockIcon from "@/assets/svg/rebuild/clock_icon.svg";

import BulletList from "../common/BulletList";
import CurrentStep from "../common/CurrentStep";
import CoinsCount from "../common/CoinsCount";

export default {
  name: "QuizQuestionMobileHeader",
  props: ["currentNumberQuestion", "questionDetails", "bullets", "data"],
  data() {
    return {
      clockIcon
    };
  },
  components: {
    BulletList,
    CurrentStep,
    CoinsCount
  }
};
</script>

<style lang="scss" scoped>
.question__header {
  margin-bottom: 35px;
  margin-top: 10px;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 10px;
  margin-bottom: 15px;
}

.header__timer {
  display: flex;
  align-items: flex-end;
}

.timer__count {
  font-size: 22px;
  font-weight: bold;
}

.timer__icon {
  margin-left: 5px;
}
</style>
